<template>
  <div class="training-school">
    <div class="training-school-inner">
      <div class="training-school-head">
        <img src="@/assets/images/maticmanage/maticmanage.png" />
        <ul class="training-schoolul">
          <li
            class="training-school-headtext"
            v-for="(item,index) in tablist"
            :key="index"
            :class="{ active: tabActive === index }"
            @click="tabHandleChange(index)"
          >{{item.title}}</li>
        </ul>
        <div class="gdbox">
          <div class="gdtext">更多</div>
          <img src="@/assets/images/home/arrows.png" class="gdimg" />
        </div>
      </div>
      <div class="trainingvideo">
        <div class="trainingvideleft">
          <img
            class="videopalybox"
            :src="QuestionOneList.imgUrl"
            @click="newsVideo(QuestionOneList.id)"
          />

          <div class="trainglefttext">
            <div class="traingleftname">{{QuestionOneList.jzName}}</div>
            <p>{{QuestionOneList.name}}</p>
          </div>
          <div class="traingimgnametxtlil">
            <div class="traintext"></div>
            <div class="trainicon" style="margin-right:14px">
              <img src="@/assets/images/traningschool/videoplimg.png" alt />
              <span>23</span>
            </div>
            <div class="trainicon">
              <img src="@/assets/images/traningschool/talkimg.png" alt />
              <span>16</span>
            </div>
          </div>
        </div>
        <div class="trainingvideright">
          <div
            class="trainingimgli"
            v-for="(item,index) in QuestionList"
            :key="index"
            @click="newsVideo(item.id)"
          >
            <img :src="item.imgUrl" />
            <i class="play-btn el-icon-video-play"></i>
            <div class="traingimgtext">
              <div class="traingimgname">{{item.jzName}}</div>
              <p>{{item.name}}</p>
            </div>
            <div class="traingimgnametxtlil">
              <div class="traintext"></div>
              <div class="trainicon" style="margin-right:14px">
                <img src="@/assets/images/traningschool/videoplimg.png" alt />
                <span>23</span>
              </div>
              <div class="trainicon">
                <img src="@/assets/images/traningschool/talkimg.png" alt />
                <span>16</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as studyClassIndex from '@/api/studyClass/index';
export default {
  data() {
    return {
      QuestionOneList: '',
      QuestionList: '',
      opsterimg:
        'http://121.12.125.214:2364/images/%E9%A6%96%E9%A1%B5/%E8%A7%86%E9%A2%91_u139.png',
      nodownload: false,
      isPlay: false,
      isIn: false,
      autoplay: false,
      isviposter: true,

      tabActive: 0,
      tablist: [
        {
          title: '政工专题',
          id: 1,
        },
      ],
      listright: [
        {
          id: 1,
          title: '刑侦',
          Number: 30,
          url: require('@/assets/images/dill-column/statistics01.png'),
          color: '#DC262D',
        },
        {
          id: 2,
          title: '政工',
          Number: 25,
          url: require('@/assets/images/dill-column/statistics02.png'),
          color: '#E58322',
        },
        {
          id: 3,
          title: '指挥',
          Number: 29,
          url: require('@/assets/images/dill-column/statistics03.png'),
          color: '#227DE5',
        },
        {
          id: 4,
          title: '纪检',
          Number: 26,
          url: require('@/assets/images/dill-column/statisticscommon.png'),
        },
        {
          id: 5,
          title: '警保',
          Number: 25,
          url: require('@/assets/images/dill-column/statisticscommon.png'),
        },
        {
          id: 6,
          title: '刑侦',
          Number: 30,
          url: require('@/assets/images/dill-column/statisticscommon.png'),
        },
        {
          id: 7,
          title: '法制',
          Number: 28,
          url: require('@/assets/images/dill-column/statisticscommon.png'),
        },
      ],
    };
  },
  mounted() {
    this.MoocQuestionList();
  },
  methods: {
    // 专题管理课件列表
    MoocQuestionList() {
      let data = { top: 8 };
      studyClassIndex.MoocQuestionList(data).then((res) => {
        // console.log(res.result);
        let list = res.result;
        this.QuestionList = list.slice(1, 7);
        this.QuestionOneList = list[0];
      });
    },
    //跳转到新页面进入视频的播放
    newsVideo(id) {
      this.$router.push('/studyclassDetail?id=' + id);
    },
    tabHandleChange(index) {
      this.tabActive = index;
      this.$emit('tabChange', this.tabActive);
    },

    // 点击屏幕播放
    suspend() {
      let myVideo = this.$refs.videoto;
      // this.isPlay = !this.isPlay;
      if (this.isPlay) {
        myVideo.play();

        this.isPlay = false;
        this.isviposter = false; //隐藏封面
      } else {
        myVideo.pause();
        this.isPlay = true;
      }
    },
    // 点击播放
    playVideock() {
      //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
      let myVideo = this.$refs.videoto;
      myVideo.play();
      this.isPlay = true;
      this.isviposter = false;
    },
    // 点击暂停
    pauseVideo() {
      let myVideo = this.$refs.videoto;
      myVideo.pause();
      this.isPlay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.training-school {
  margin: 20px 0;
  > .training-school-inner {
    width: 1200px;
    margin: 0 auto;
    border-radius: 6px;
    background-color: #fff;
    .training-school-head {
      display: flex;
      align-items: center;
      padding: 3px 12px 3px 8px;
      list-style-type: none;
      border-bottom: {
        width: 2px;
        style: solid;
      }
      box-sizing: border-box;
      display: flex;

      @include themeify {
        border-color: themed('color-border-base');
      }
      .training-schoolul {
        flex: 1;
        display: flex;
        line-height: 50px;
        .training-school-headtext {
          font-size: 22px;
          font-weight: 500;
          line-height: 37px;
          margin-left: 20px;
          // @include style-h(0.9);

          @include themeify {
            color: themed('color-text-secondary');
            border-color: themed('color-border-base');
          }
          &.active {
            @include themeify {
              color: themed('color-primary');
              border-bottom-color: themed('color-background-base');
            }
          }
        }
      }
    }
    .trainingvideo {
      padding: 24px 20px;
      display: flex;
      .trainingvideleft {
        width: 446px;
        height: 321px;
        border-radius: 6px;
        .videopalybox {
          position: relative;
          width: 446px;
          height: 321px;
          .videopalys {
            border-radius: 6px;
          }
        }

        .trainglefttext {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #666;
          margin-top: 6px;
          .traingleftname {
            padding: 3px 5px;
            color: #fff;
            background-color: #4876c4;
            border-radius: 4px;
            font-size: 13px;
            margin-right: 5px;
          }
        }
      }
      .trainingvideright {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        .trainingimgli {
          width: 222px;
          margin: 0 0 15px 14px;
          position: relative;
          img {
            width: 222px;
            height: 136px;
            border-radius: 6px;
          }
          .play-btn {
            font-size: 27px;
            color: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -28px;
            transform: translate(-50%, -50%);
            &:hover {
              cursor: pointer;
            }
          }
          .traingimgtext {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #666;
            margin-top: 6px;
            .traingimgname {
              padding: 3px 5px;
              color: #fff;
              background-color: #4876c4;
              border-radius: 4px;
              font-size: 13px;
              margin-right: 8px;
            }
          }
          .traingimgnametxtlil {
            color: #999;
            font-size: 14px;
            display: flex;
            margin-top: 6px;
            .traintext {
              flex: 1;
            }
            .trainicon {
              display: flex;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
                margin-right: 2px;
              }
            }
          }
        }
      }
    }
  }
}

.traingimgnametxtlil {
  color: #999;
  font-size: 14px;
  display: flex;
  margin-top: 6px;
  .traintext {
    flex: 1;
  }
  .trainicon {
    display: flex;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
      margin-right: 2px;
    }
  }
}

.gdbox {
  display: flex;
  align-items: center;
  line-height: 50px;
  .gdtext {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    opacity: 1;
  }
  .gdimg {
    margin: 0 23px 0 8px;
  }
}

.play-btn {
  font-size: 50px;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &:hover {
    cursor: pointer;
  }
}
</style>
